






import Vue from "vue";
import { Brand } from "@megarax/client/src/resources/plm";

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: Brand,
      required: true,
    },
  },
});
